import { NavBar, Tab, Tabs, Grid, GridItem } from 'vant';
export default {
  components: {
    [NavBar.name]: NavBar,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs
  },

  data() {
    return {
      active: "人"
    };
  },

  computed: {
    activeMenu() {
      const route = this.$route;
      const {
        meta,
        path
      } = route;

      if (meta.activeMenu) {
        return meta.activeMenu;
      }

      return path;
    }

  },
  methods: {},

  mounted() {}

};